export const formatPrice = (value) => {
    let n = value;
    n = n.toString().replace(",", ".").replace(/([^0-9]+)/g, "");
    n = Number(parseFloat(n).toFixed(4) + 0);

    return addThousandSeparator(handleDecimals(n));
}

export const addThousandSeparator = (n) => {
    const nStr = n.toString();
    const remainder = nStr.length % 3;

    let formatted = (nStr.substr(0, remainder) + nStr.substr(remainder).replace(/(\d{3})/g, ' ' + "$1")).trim();

    if (formatted[0] === ' ') {
        formatted = formatted.substr(1);
    }

    return formatted;
}

export const handleDecimals = (n) => {
    return Number.isInteger(n) ? parseInt(n) : n.toFixed(2);
}
